import { useEffect, useState } from 'react'
import { registryService } from 'services'
import { ICity } from 'interfaces'

function useCities(setError?: (error: any) => void) {
  const [cities, setCities] = useState<ICity[]>([])

  useEffect(() => {
    const controller = registryService.getCities(setCities, setError)
    return () => controller.abort()
  }, [setError])

  return cities
}

export default useCities
